import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";

function AddNewFolder({ open, onClose, onSubmit, loading, error }) {
  const [folderName, setFolderName] = useState("");

  useEffect(() => {
    if (!open) {
      setFolderName("");
    }
  }, [open]);

  const handleSubmit = () => {
    if (folderName.trim()) {
      onSubmit(folderName.trim());
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add New Folder</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Folder Name"
          fullWidth
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && folderName.trim()) {
              e.preventDefault();
              handleSubmit();
            }
          }}
          disabled={loading}
          error={!!error}
          helperText={error}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={!folderName.trim() || loading}
        >
          {loading ? <CircularProgress size={24} /> : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddNewFolder;
